import {css} from 'styled-components';

// Base look shared by every antd `Sender` used for agent chat entry points
// (FullWidthAgentChat's footer, QuickAgentAction's card). Callers layer their
// own deltas (borders, shadows, focus states) on top via their own `.ant-sender` block.
export const agentSenderStyles = css`
  .ant-sender {
    background-color: ${props => props.theme.colors.neutral_1};
    border-radius: 12px;

    .ant-btn.ant-btn-icon-only {
      font-size: 16px;

      &.ant-sender-actions-btn {
        &:not(.ant-sender-actions-btn-disabled) {
          color: ${props => props.theme.colors.primary_6};
        }
      }
    }
  }

  .ant-sender-content {
    padding: 5px 10px;
  }
`;
